/** Extract explicit references without truncating notes or guessing invoice digits. */
export function squareInvoiceNumbers(value: string): number[] {
  const note = (value || '').replace(/^\s*Sale of item\(s\):\s*/i, '').replace(/^\s*Refund\s+/i, '').trim();
  const references = [...note.matchAll(/\b(?:invoice|inovice|invocie|invoce|inv)\.?\s*(?:(?:no\.?|number)\s*)?[#:\-]?\s*(\d{3,6})\b/gi)]
    .map(match => Number(match[1]));
  if (!references.length && /^#?\s*\d{3,6}$/.test(note)) references.push(Number(note.replace(/^#\s*/, '')));
  return [...new Set(references.filter(number => number > 0))];
}

// Keep API and CSV descriptions consistent with the bank-transfer note limit.
export function formatSquareNote(value: string, refund = false): string {
  let note = (value || '').replace(/^\s*Sale of item\(s\):\s*/i, '').trim();
  note = note.replace(/^Refund\s+/i, '').trim();
  if (!note || /^Custom\s+Amount$/i.test(note)) note = 'inv ????';
  else if (/^quick[\s-]*service$/i.test(note)) note = 'Quick Service';
  else {
    // Normalize spelling/format only; never guess or alter handwritten digits.
    note = note.replace(/\b(?:invoice|inovice|invocie|invoce|inv)\.?\s*(?:(?:no\.?|number)\s*)?[#:\-]?\s*(\d{3,6})\b/gi, 'inv $1');
    if (/^#\s*\d{3,6}$/.test(note)) note = note.replace(/^#\s*/, 'inv ');
    if (/^\d{3,6}$/.test(note)) note = `inv ${note}`;
    const invoice = note.match(/\binv \d{3,6}\b/i);
    if (invoice && !/^inv \d/i.test(note)) {
      note = `${invoice[0]} ${note.replace(invoice[0], '').trim()}`.trim();
    }
  }
  return `${refund ? 'Refund ' : ''}${note}`.slice(0, 24);
}

export function squareNoteFromDetails(payment: any, order?: any): string {
  const notes = [payment?.note, ...(order?.line_items || []).map((item: any) => item.note),
    ...(order?.tenders || []).filter((tender: any) => tender.id === payment?.id).map((tender: any) => tender.note)];
  const names = (order?.line_items || []).map((item: any) => item.name);
  const values = [...notes, ...names, payment?.reference_id, order?.reference_id]
    .filter((value): value is string => typeof value === 'string' && !!value.trim())
    .map(value => formatSquareNote(value));
  const invoiceNotes = [...new Set(values.filter(value => /\binv \d{3,6}\b/i.test(value)))];
  // Preserve conflicting notes for review rather than selecting one invoice silently.
  if (invoiceNotes.length) return invoiceNotes.join(' / ');
  return values.find(value => value !== 'inv ????') || 'inv ????';
}
